import moment from 'moment-timezone';

/**
 * Duration math and duration-formatting helpers.
 */

export const durationToMinutes = (duration) => {
	if (!duration) return 0;

	const [hours = 0, minutes = 0] = String(duration)
		.split(':')
		.map((part) => Number(part));

	if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return 0;

	return hours * 60 + minutes;
};

export const calculateDuration = (departure, arrival, short = false) => {
	const differences = moment.duration(moment(arrival).diff(moment(departure)));
	const hours = Math.floor(differences.asHours());
	const minutes = differences.minutes();
	if (short) return `${hours > 0 ? `${hours}h` : ''} ${minutes}min`;
	return `${hours > 0 ? `${hours} h` : ''} ${minutes} min`;
};

export const getDurationBetweenTimestamps = (startTimestamp, endTimestamp) => {
	const start = moment.utc(startTimestamp);
	const end = moment.utc(endTimestamp);
	const duration = moment.duration(end.diff(start));

	const hours = Math.floor(duration.asHours());
	const minutes = duration.minutes();
	const hoursPart = hours > 0 ? `${hours}h` : '';
	const minutesPart = minutes > 0 ? `${minutes}m` : '';
	return [hoursPart, minutesPart].filter(Boolean).join(' ');
};

export const minutesToDuration = (totalMinutes) => {
	const minutes = Number(totalMinutes);

	if (!Number.isFinite(minutes) || minutes < 0) {
		return '00:00';
	}

	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;

	return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

export const minutesDuration = (minsInt) => {
	const duration = moment.duration(minsInt, 'minutes');
	const minutes = duration.minutes();
	const hours = Math.floor(duration.asHours());
	if (hours === minutes && hours === 0) {
		return '0hrs';
	}
	return `${hours === 0 ? '' : `${hours}hrs`} ${minutes === 0 ? '' : `${minutes}m`}`;
};
